import { ca } from '@cian/analytics';

export const trackEstimatorBannerButton = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'New_ad',
    action: 'click',
    label: 'EstateCalculatorButton',
  });
};
